import React from 'react';
import { Sparkles } from 'lucide-react';
import { publicAsset } from '@/utils/publicAsset';

export interface PamNoteProps {
  label: string;
  children: React.ReactNode;
  testId?: string;
}

/** Pam's plum ledge note, the one voice surface every diagnostic turn uses. */
export const PamNote: React.FC<PamNoteProps> = ({ label, children, testId }) => (
  <div
    data-testid={testId}
    className="rounded-2xl border-2 border-accent-200 bg-accent-50 p-4 sm:p-5"
    style={{ boxShadow: '0 4px 0 0 rgba(139,90,124,0.20)' }}
  >
    <div className="flex items-start gap-3">
      <img
        src={publicAsset('pamela-image.png')}
        alt=""
        className="w-11 h-11 rounded-full object-cover flex-shrink-0 ring-2 ring-accent-200"
      />
      <div className="min-w-0">
        <p className="flex items-center gap-1.5 text-[11px] font-extrabold uppercase tracking-wider text-accent-700 mb-1">
          <Sparkles className="w-3.5 h-3.5" /> {label}
        </p>
        <div className="text-[15px] font-bold text-neutral-900 leading-snug">{children}</div>
      </div>
    </div>
  </div>
);
